var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusCells(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 81,
    viewBox: "0 0 120 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1953",
    "data-name": "Group 1953",
    transform: "translate(-360 -479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1831",
    "data-name": "Group 1831",
    transform: "translate(-11472 -8704)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147900",
    "data-name": "Rectangle 147900",
    width: 15,
    height: 15,
    transform: "translate(11832 9183)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147907",
    "data-name": "Rectangle 147907",
    width: 98,
    height: 15,
    transform: "translate(11854 9183)",
    fill: "#c2c4c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147903",
    "data-name": "Rectangle 147903",
    width: 15,
    height: 15,
    transform: "translate(11832 9249)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147904",
    "data-name": "Rectangle 147904",
    width: 98,
    height: 15,
    transform: "translate(11854 9249)",
    fill: "#c2c4c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147901",
    "data-name": "Rectangle 147901",
    width: 15,
    height: 15,
    transform: "translate(11832 9205)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147906",
    "data-name": "Rectangle 147906",
    width: 98,
    height: 15,
    transform: "translate(11854 9205)",
    fill: "#c2c4c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147902",
    "data-name": "Rectangle 147902",
    width: 15,
    height: 15,
    transform: "translate(11832 9227)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147905",
    "data-name": "Rectangle 147905",
    width: 98,
    height: 15,
    transform: "translate(11854 9227)",
    fill: "#c2c4c6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCells);
export default __webpack_public_path__ + "static/media/statusCells.f7e13a9fc85d2490dcc33fdb49fbccc5.svg";
export { ForwardRef as ReactComponent };